module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select-single layui-unselect layui-form-select",
    class: {
      'layui-form-selected': _vm.selectShow
    }
  }, [_c('div', {
    staticClass: "layui-select-title"
  }, [_c('input', {
    staticClass: "layui-input layui-unselect",
    attrs: {
      "type": "text",
      "placeholder": "--------请选择--------",
      "readonly": ""
    },
    domProps: {
      "value": _vm.currentValue.Text
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSelect($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "layui-edge",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSelect($event)
      }
    }
  })]), _vm._v(" "), _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectShow),
      expression: "selectShow"
    }],
    staticClass: "layui-anim layui-anim-upbit"
  }, _vm._l((_vm.currentOptions), function(item, index) {
    return _c('dd', {
      key: index,
      class: {
        'layui-this': _vm.currentValue.Value == item.Value
      },
      attrs: {
        "value": "item.Value"
      },
      on: {
        "click": function($event) {
          _vm.currentSelect(item)
        }
      }
    }, [_vm._v(_vm._s(item.Text))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5ba582e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmSelect.vue
// module id = 335
// module chunks = 2